import { ParsedChartReturn } from '#components/chart/types';
import { Prettify } from '#types';
import { createContext } from 'react';
import { Props as ResponsiveContainerProps } from 'recharts/types/component/ResponsiveContainer';

type ChartContextType = {
  options: ChartContextOptions;
  data: ParsedChartReturn;
  isCalculated: boolean;
};

export type ChartColors = {
  HIGHLIGHT_POSITIVE: string;
  HIGHLIGHT_NEGATIVE: string;

  TOOLTIP_CURRENT: string;
  TOOLTIP_TARGET: string;
  TOOLTIP_TARGET_BOTH: string;

  CURRENT_LINE: string;
  CURRENT_DOTS: string;
  CURRENT_DOT_FILL: string;
  CURRENT_ACTIVE_DOT: string;

  XAXIS_LINE: string;
  XAXIS_TEXT: string;
  YAXIS_TEXT: string;
  UNIT_TEXT: string;

  REFERENCE_LINE: string;
  CURSOR_LINE: string;

  TARGET_AXIS_TEXT: string;
  TARGET_AXIS_ACTIVE_TEXT: string;
  TARGET_LINE: string;
  TARGET_DOTS: string;
  TARGET_ACTIVE_DOT: string;

  GRID_LINE: string;

  DOT_FILL: string;
};

export type ChartContextOptions = {
  reversed: boolean;
  highLightedZone?: 'positive' | 'negative' | 'none';
  size?: 'sm' | 'md';
  showUnit?: boolean;
  colors: ChartColors;
} & Omit<ResponsiveContainerProps, 'onResize' | 'children'>;

export type ChartContextConfigurableOptions = Prettify<
  Pick<
    ChartContextOptions,
    | 'highLightedZone'
    | 'height'
    | 'width'
    | 'minWidth'
    | 'maxHeight'
    | 'minHeight'
    | 'initialDimension'
  >
>;

export const ChartContext = createContext<ChartContextType>(
  null as unknown as ChartContextType,
);
